import React from "react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { CORE_PRODUCTS } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import { useWaitlist } from "@/context/WaitlistContext";

export const CoreProducts = () => {
  const { openWaitlist } = useWaitlist();
  return (
    <section id="core-products" data-testid="core-products" className="relative bg-gradient-to-b from-ivory via-ivory-light to-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          overline="The platform"
          title="One brand, four ways to hold gold"
          accentWord="four ways"
          subtitle="A complete gold wealth architecture — from your first ₹10 to a borderless family portfolio."
        />

        <StaggerGroup className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4" stagger={0.09}>
          {CORE_PRODUCTS.map((p, i) => (
            <StaggerItem key={p.name}>
              <button
                data-testid={`core-product-${i}`}
                onClick={() => openWaitlist("core-product")}
                className="glass-card group flex h-full w-full flex-col rounded-3xl p-7 text-left transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-12px_rgba(212,175,55,0.3)]"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-gold via-gold-amber to-gold-rose shadow-[0_6px_18px_-4px_rgba(212,175,55,0.5)]">
                  <p.icon className="h-6 w-6 text-charcoal-deep" strokeWidth={1.9} />
                </div>
                <h3 className="font-serif text-xl font-normal text-charcoal">{p.name}</h3>
                <p className="mt-1 text-sm font-semibold text-gold">{p.tagline}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal-soft">{p.body}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-charcoal transition-colors group-hover:text-gold">
                  Explore <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </button>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
